module.exports = __webpack_public_path__ + "static/media/o-complete.6793c745.svg";